<template>
  <div class="container">
    <b-row>
      <b-col>
        <Visualizar />
      </b-col>
    </b-row>

    <b-row class="row-button">
      <b-col class="one">
        <Help
          :title="title"
          :text="text"
          :uno="uno"
          :dos="dos"
          :tres="tres"
          :cuatro="cuatro"
          :cinco="cinco"
          :seis="seis"
        />
      </b-col>
      <b-col v-if="readOnly"> </b-col>

      <b-col v-else class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          @click="guardarBorrador"
          v-if="userPermissions"
        >
          Guardar como borrador
        </b-button>
        <b-button
          pill
          variant="primary"
          class="btn-two"
          @click="guardarFinalizado"
          v-if="userPermission"
        >
          Guardar y finalizar
        </b-button>
      </b-col>
    </b-row>

    <h5 class="title">Incentivo Colectivo</h5>

    <div  v-if="!checked" class="title-head">
      <h3 class="titulo-c3">
        Cumplimiento Convenio de Desempeño Colectivo
      </h3>
    </div>

    <b-row v-if="userPermissions" class="">
      <b-form-checkbox
        style="display:flex;   justify-content: flex-end; "
        v-model="checked"
        name="check-button"
        switch
      >
        <span class="span" v-if="checked"> No Aplica</span>
        <span class="span" v-else>No Aplica</span>
      </b-form-checkbox>
    </b-row>

    <div v-if="checked">
      <AlertError />
    </div>

    <div v-else>
      <Cuadro11
        :readOnly="readOnly"
        :addItemList="addItemList"
        :itemList="itemList"
        :removeItem="removeItem"
      />
    </div>
  </div>
</template>

<script>
import Visualizar from "../../../components/button/escritorio/Visualizar.vue";
import Help from "../../../components/tools/Modal";
import Cuadro11 from "./Cuadro11/Cuadro11.vue";
import Swal from "sweetalert2";
import axios from "axios";
import { showAlert } from "@/components/tools/utils";
import { mapState } from "vuex";
import AlertError from "../../../components/error/AlertError.vue";

export default {
  components: {
    Visualizar,
    Help,
    Cuadro11,
    AlertError,
  },
  data() {
    return {
      itemList: [],
      anio: process.env.VUE_APP_ANIO,
      nombre: "colectivo",
      userPermission: true,
      userPermissions: true,
      datosUser: null,
      title: "Incentivo Colectivo",
      text:
        "Para el periodo 2018 – 2020, se debe informar lo siguiente respecto del Convenio de Desempeño Colectivo (CDC) para cada año:",
      uno: "	Columna 1: Año",
      dos: "	Columna 2: Total de equipos trabajo incluidos en el CDC del año",
      tres:
        "	Columna 3: Número promedio de personas por equipo de trabajo, esto es:(Suma del N° de funcionarios de cada equipo de trabajo / Total de equipos de trabajo)",
      cuatro:
        "	Columna 4: Número promedio de metas comprometidas por equipo de trabajo, esto es:(Suma del N° de metas de cada equipo de trabajo / Total de equipos de trabajo)",
      cinco:
        "	Columna 5: promedio simple del porcentaje de cumplimiento de los equipos de trabajo, esto es:(Suma del % de cumplimiento de cada equipo de trabajo / Total de equipos de trabajo)",
      seis:
        "	Columna 6: Monto total anual en pesos pagado por el incremento por desempeño colectivo",
      checked: true,
    };
  },
  props: ["readOnly"],
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        data: {
          content: this.itemList,
          aplica: this.checked,
        },
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    addItemList: function() {
      const toAddObj = {
        anio: "",
        equiposTrabajo: "",
        nPersonasEquipo: "",
        metasGestion: "",
        percCump: "",
        incrementoDes: "",
      };
      this.itemList.push(toAddObj);
    },
    removeItem: function(index) {
      const pos = this.itemList.indexOf(index);

      this.itemList.splice(pos, 1);
    },
    guardarBorrador: async function() {
      const toSend = this.buildData("borrador");
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          toSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
        console.log(res);
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              content: this.itemList,
              aplica: this.checked,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );

          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
        console.log(error);
      }
    },
    guardarFinalizado: async function() {
      const toSend = this.buildData("finalizado");

      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar los datos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              toSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );
            showAlert({
              icon: "success",
              text: "Guardado y finalizado exitosamente.",
              timerProgressBar: true,
              timer: 3000,
            });
            console.log(res);
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  content: this.itemList,
                  aplica: this.checked,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );

              showAlert({
                icon: "success",
                text: "Guardado y finalizado exitosamente.",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
            console.log(error);
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${this.anio}&nombre=${this.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );


        res.data.info= res.data.info || {}
        this.checked = res.data.info.aplica || false;
        
        if (res.data.info.content) {
          this.itemList = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    },

   obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    
  },
  mounted() {
    this.obtenerContenido();
    this.obtenerRevision()
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}
.btn-one {
  margin-right: 20px;
}

.btn-direction-flex {
  text-align: end;
}

.title {
  text-align: center;
  color: #052333;
  font-size: 1.6rem;
}
h5 {
  font-weight: bold;
  text-align: center;
}

.title-head {
  padding: 10px 15px;
  text-align: center;
}
.titulo-c3 {
  font-size: 1.4rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
}

.row-button {
  margin-bottom: 30px;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
}
@media screen and (max-width: 784px) {
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .one {
    display: none;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
    position: relative;
    top: -6px;
  }
  .btn-direction-flex {
    text-align: start;
    margin-left: 30px;
  }
}
</style>
